"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInt = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
function isInt(value, exponent) {
    const num = new bignumber_js_1.default(value);
    return (num.isInteger() &&
        num.gte(-(2 ** exponent / 2)) &&
        num.lte(2 ** exponent / 2 - 1));
}
exports.isInt = isInt;
